{
    "TelephoneserverLabel": "Serveur téléphonique :",
    "PartitionsLabel": "Partition(s) :",
    "ScopeFiltering_SectionHeader": "Filtrage de la portée",
    "NAME": "ScopeFiltering",
    "ScopeGroupsLabel": "Groupe(s) concerné(s):",
    "AnyScopeGroupsLabel": "[Tous les groupes de portée]"
}